export const WEEK_MODE_WEEKS_COUNT_DEFAULT = 1;
